import { clamp, expSmooth } from './math.js';

/**
 * A value that eases towards its target *and* refuses to move faster than a
 * fixed rate. The rate limit is the anti-strobe primitive: no matter how
 * violently the music jumps, anything driven through a `Gentle` changes at a
 * speed the eye reads as motion rather than as a flash.
 */
export class Gentle {
  private readonly halfLifeSeconds: number;
  private readonly maxRatePerSecond: number;
  private value: number;

  constructor(halfLifeSeconds: number, maxRatePerSecond: number, initial = 0) {
    this.halfLifeSeconds = halfLifeSeconds;
    this.maxRatePerSecond = maxRatePerSecond;
    this.value = initial;
  }

  public update(target: number, deltaSeconds: number): number {
    const eased = expSmooth(this.value, target, deltaSeconds, this.halfLifeSeconds);
    const limit = this.maxRatePerSecond * deltaSeconds;
    this.value += clamp(eased - this.value, -limit, limit);
    return this.value;
  }

  public get current(): number {
    return this.value;
  }
}
